import { Container, TOKENS } from '@repo/core';
import { SentryAnalyticsService } from '../services/analytics';
import { SentryLoggingService } from '../services/logging';
import { WebNotificationService } from '../services/notification';
import { LocalStorageService } from '../services/storage';

/**
 * Creates the production DI container with all real service implementations.
 * Called once in main.tsx.
 *
 * To override services in tests, use createTestContainer() or
 * container.createChild().provide(TOKENS.Analytics, mockAnalytics).
 */
export function createAppContainer(): Container {
  return new Container()
    .provide(TOKENS.Analytics, new SentryAnalyticsService())
    .provide(TOKENS.Storage, new LocalStorageService())
    .provide(TOKENS.Logging, new SentryLoggingService())
    .provide(TOKENS.Notification, new WebNotificationService());
}
